export enum EditCandidateActions {
  EditStarted = 'EDIT_STARTED',
  Updated = 'UPDATED',
  Deleted = 'DELETED',
}
